import * as React from 'react';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { borderSubtle, layoutCardRadius, surfaceCard } from '../../theme/colors';

const StyledBox = styled(Box)({
  backgroundColor: surfaceCard,
  padding: '24px',
  border: `1px solid ${borderSubtle}`,
  borderRadius: layoutCardRadius,
});

const FormBox = ({ children }) => {
  return <StyledBox>{children}</StyledBox>;
};

export default FormBox;
